import styled from 'styled-components';

export const HeaderMenu = styled.div`
  width: 100%;
  height: 66px;
  background: var(--color-blue-primary);
  position: fixed;
  top: 0;
  display: flex;
  z-index: 1999;
  flex-direction: row;
  align-items: center;

  user-select: none;

  #container-logo-header {
    min-width: 237px;

    img {
      width: 95px;
      height: auto;
      margin-left: 28px;
    }
  }

  #container-settings-header {
    width: 100%;
    max-width: calc(100% - 237px);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 33px;
  }

  #container-user {
    display: flex;
    flex-direction: row;
  }
`;
